<template>

    <div class="categories__node" :class="levelClass">

        <div class="category">

            <div :ref="getParentsParams()" class="title" @click="toggleExpand()" :class="{active: expanded}"> 
                <i class="dropdown icon"></i> {{category.name}} <span v-if="category.loading" class="ui mini loader"></span>
            </div>

            <div class="content" :class="{ active: expanded }">

                <div class="resources" v-if="hasResources">
                    <ul>
                        <li v-for="item in category.additionalContent" :key="item.id">
                            <i class="teal fas" :class="resourceIcon(item.resource, item)" ></i>
                            <a :ref="getParentsParamsForResource(item.resource)" :class="isItemDownloadable(item)" :href="resourceUrl(item)" :target="resourceAnchorTarget(item.resource)" >{{item.resource.name}}</a>
                        </li>
                    </ul>
                </div>

                <div class="subcategories" v-if="hasSubcategories">
                    <category-node :userstatus="getuserStatus" v-for="child in category.children" :key="child.id" :category="child" :level="level + 1" :parents="parentArray" :searchUrlParams="searchUrlParams"></category-node>
                </div>

                <div class="no-content" v-if="!category.loading && !hasContent">
                    Kategorija nima gradiv in podkategorij
                </div>

            </div>

        </div>

    </div>

</template>

<script>
import CategoryNode from './CategoryNode'

const iconMap = {
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'fa-file-word',
    'application/pdf': 'fa-file-pdf',
    'application/msword': 'fa-file-word',
    'text/rtf': 'fa-file-alt',
    'application/vnd.ms-powerpoint': 'fa-file-powerpoint',
    'application/vnd.ms-powerpoint': 'fa-file-powerpoint',
    'audio/mpeg': 'fa-file-audio',
    'text/html': 'fa-file-code',
    'application/vnd.ms-excel': 'fa-file-excel',
    'image/jpeg': 'fa-file-image',
    'image/png': 'fa-file-image',
    'audio/x-wav': 'fa-file-audio',
    'video/x-ms-asf': 'fa-file-video',
    'video/mp4': 'fa-file-video',
    'video/quicktime': 'fa-file-video',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'fa-file-powerpoint',
    'application/zip': 'fa-file-archive',
    'application/x-rar': 'fa-file-archive',
    'application/CDFV2': 'fa-file-word',
    'video/x-msvideo': 'fa-file-video',
    'application/octet-stream': 'fa-file-audio'

}

export default {
    name: 'category-node',
    components: {
        CategoryNode
    },
    props: ['rootCategory', 'category', 'level', 'userstatus', 'parents', 'searchUrlParams'],
    data() {
        return {
            expanded: false,
            parentArray: [],
            resourceLevel: undefined
        }
    },
    mounted() {
        if (this.rootCategory) {
            this.parentArray.push(this.rootCategory.id, this.category.id);
        } else {
            this.parentArray = this.parents.concat([this.category.id]);
        }
        // rekurzivno odpiranje kategorij - če obstajajo search url parametri
        if (this.searchUrlParams && this.searchUrlParams.length >= this.level) {             
            if (this.searchUrlParams[this.level - 1] == this.category.id) {
                this.$nextTick(() => {
                    this.$refs[this.getParentsParams()].click();
                    if (this.searchUrlParams.length === this.level + 1) { // click the resource if on end of array
                        setTimeout(() => {
                            const rootCategory = this.parents[0]; // prve kategorije ni v "this.searchUrlParams", ker smo jo že v osnovni komponenti odrezali
                            const newParam = rootCategory + "-" + this.searchUrlParams.join("-");
                            this.$refs[newParam] && this.$refs[newParam][0].click();
                        }, 1000);                        
                    }
                });
            }
        }
    },
    methods: {
        getParentsParams() {
            return this.parentArray.join("-");
        },
        getParentsParamsForResource(resource) {
            const unique_id = resource.unique_id.replaceAll("-", ":");
            return this.parentArray.concat([unique_id]).join("-");
        },
        checkForResources() {
            return this.category.loaded && this.category.additionalContent.length > 0
        },
        toggleExpand(state) {
            if (state) {
                this.expanded = state
            } else {
                this.expanded = !this.expanded
            }
            if (this.expanded && !this.category.loaded) {
                this.loadCategory(this.category)
            }
        },
        isItemDownloadable(item) {
            const visibleTo = (item || { visibility: "teacher"})['visibility'];
            const statuses = { 
                "all": visibleTo === "students" ? "students-only" : (visibleTo === "teacher" ? "teachers-only" : ""),
                "student": visibleTo === "teacher" ? "teachers-only" : "",
                "teacher": "",
            }
            return statuses[this.userstatus];
        },
        resourceIcon(resource) {
            if (resource.type == 'url') {
                return `fa-link`
            }
            if (resource.type == 'file') {
                return iconMap[resource.mime];
            }
            return `fa-file`;
        },
        resourceUrl(item) {
            if (item.resource.type == 'url') {
                return item.resource.path
            }
            if (item.resource.type == 'file') {
                if (this.userstatus == 'all' && item.visibility !== 'all') {  // user not logged in and item not free for download - redirect to log in
                    return this.route('dodatna-gradiva') + '?' + new URLSearchParams({
                        callbackParams: this.getParentsParamsForResource(item.resource)
                    });
                } else { // user logged in - return resource url
                    return this.route('dodatna-gradiva') + '?' + new URLSearchParams({
                        resource: item.resource.unique_id
                    });
                }
            }
        },
        resourceAnchorTarget(resource) {
            return resource.type == 'url' ? '_blank' : '_self';
        }
    },
    computed: {
        console: () => console,
        hasContent() {
            return this.hasResources || this.hasSubcategories
        },
        levelClass() {
            return `level-${this.level}`
        },
        hasResources() {
            return this.category.loaded && this.category.additionalContent.length > 0
        },
        hasSubcategories() {
            return this.category.loaded && this.category.children.length > 0
        },
		getuserStatus() {
			return this.userstatus;
		}
    },
    inject: ['loadCategory']
}

</script>




// WEBPACK FOOTER //
// resources/assets/js/components/CategoryNode.vue